import { Button, Modal } from 'antd';
import ModalHeader from './ModalHeader';
import FetchError from './FetchError';
import Loading from '../Loading';

type QualitativeFactorDeleteModalProps = {
  title: string;
  isOpen: boolean;
  onCancel: () => void;
  onDelete?: () => void;
  loading?: boolean;
  error?: any;
  hasItApplications?: boolean;
};

const QualitativeFactorDeleteModal = ({
  title,
  isOpen,
  onCancel,
  onDelete,
  loading,
  error,
  hasItApplications = false,
}: QualitativeFactorDeleteModalProps) => {
  return (
    <Modal
      title={<ModalHeader title={title} />}
      open={isOpen}
      onCancel={onCancel}
      centered
      className="custom-modal"
      footer={[
        <div className="m-4 flex justify-end gap-4">
          <Button key="back" onClick={onCancel}>
            Cancel
          </Button>
          <Button key="submit" type="primary" danger onClick={onDelete}>
            Delete
          </Button>
        </div>,
      ]}
    >
      {!loading ? (
        <div className="flex flex-col gap-4">
          {hasItApplications ? (
            <>
              <div className="flex flex-col gap-2 border-b border-gray-200 pb-3">
                <p className="font-semibold text-red-600">
                  Warning: This qualitative factor has IT applications mapped to
                  it.
                </p>
                <p>
                  Deleting this factor will delete all associated IT
                  Applications
                </p>
              </div>

              <p className="font-semibold text-red-600">
                Are you sure you want to delete this qualitative factor and
                remove all associated IT application mappings?
              </p>
            </>
          ) : (
            <p>Are you sure you want to delete this qualitative factor?</p>
          )}
        </div>
      ) : (
        <Loading />
      )}
      {error && <FetchError error={error.message} />}
    </Modal>
  );
};

export default QualitativeFactorDeleteModal;
